import deepmerge from 'deepmerge';
import React, { createContext, useContext } from 'react';
import type { DeepPartial } from '~/types';

export type ContextType = {
  dismissedNewPrice: number;
  dismissedWSYS: number;
  hasEVBannerUtm: boolean;
  openManageSavedSearchesModal: boolean;
  partnerId: number;
  sessionId: string;
  verboseLoggingEnabled: boolean;
};

const defaultContext: ContextType = {
  dismissedNewPrice: 0,
  dismissedWSYS: 0,
  hasEVBannerUtm: false,
  openManageSavedSearchesModal: false,
  partnerId: 1,
  sessionId: '',
  verboseLoggingEnabled: false
};

const StaticContext = createContext<ContextType>(defaultContext);

export type OwnProps = React.PropsWithChildren<ContextType>;

export function StaticContextProvider({ children, ...props }: OwnProps) {
  return (
    <StaticContext.Provider value={props}>{children}</StaticContext.Provider>
  );
}

StaticContextProvider.displayName = 'StaticContextProvider';

export const generateStaticContext = (
  customState: DeepPartial<ContextType>
): ContextType =>
  deepmerge<ContextType, DeepPartial<ContextType>>(defaultContext, customState);

export function MockedStaticContextProvider({
  children,
  mockValue
}: React.PropsWithChildren<{ mockValue: DeepPartial<ContextType> }>) {
  return (
    <StaticContext.Provider value={generateStaticContext(mockValue)}>
      {children}
    </StaticContext.Provider>
  );
}

export function useVerboseLogging() {
  return useContext(StaticContext).verboseLoggingEnabled;
}

export default StaticContext;
